/* eslint-disable import/prefer-default-export */
const prefix = 'brands'

export const SET_GOOD_PRACTICES = `${prefix}/SET_GOOD_PRACTICES`
